import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';

const UserSettings = ({ darkMode, setDarkMode }) => {
  const [nickname, setNickname] = useState('');
  const [darkModeLocal, setDarkModeLocal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });

  // 1. Fetch user și setări la montare
  useEffect(() => {
    const fetchUserAndSettings = async () => {
      const {
        data: { user },
        error: userError
      } = await supabase.auth.getUser();

      if (user && !userError) {
        setUserId(user.id);

        const { data, error } = await supabase
          .from('profiles')
          .select('nickname, dark_mode')
          .eq('id', user.id)
          .single();

        if (data && !error) {
          setNickname(data.nickname || '');
          setDarkModeLocal(data.dark_mode || false);
        }
      }
    };

    fetchUserAndSettings();
  }, []);

  // 2. Salvare în Supabase
  const handleSave = async (e) => {
    e.preventDefault();
    if (!userId) return;

    const { error } = await supabase.from('profiles').upsert({
      id: userId,
      nickname,
      dark_mode: darkModeLocal,
    });

    if (error) {
      setMessage({ type: 'danger', text: error.message });
    } else {
      setMessage({ type: 'success', text: 'Setările au fost salvate.' });
      setDarkMode(darkModeLocal); 
    }
  };

  // 3. JSX
  return (
    <div className="neu-container mt-4">
      <strong><h4 className="text-primary-dark">Preferințe cont</h4></strong>
      <form onSubmit={handleSave}>
        <input
          type="text"
          className="neu-input"
          placeholder="Ex: Alin"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          required
        />
        <br /><br />

        <div className="form-check form-switch neu-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="darkModeSwitch"
            checked={darkModeLocal}
            onChange={() => setDarkModeLocal(!darkModeLocal)}
          />
          <label className="form-check-label ms-2" htmlFor="darkModeSwitch">Dark Mode</label>
        </div>

        <br /><br />
        <button type="submit" className="neumorphism-button-outline">Salvează</button>
      </form>

      {message.text && (
        <p className={`text-${message.type}`}>{message.text}</p>
      )}
    </div>
  );
};

export default UserSettings;
